import PropTypes from 'prop-types'
import styled from 'styled-components'

import ToggleSwitch from 'components/Shared/ToggleSwitch/Index'
import colors from 'components/utils/colors'

const HEIGHT = 32

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 8px 0 8px;
  height: ${props => props.height || HEIGHT}px;
  font-size: 14px;
  color: ${props => props.isActive ? '#000' : (props.disabled ? colors.secondary60 : colors.secondary40)};
  user-select: none;
`

const ActiveZone = styled.div`
  display: flex;
  align-items: center;
  cursor: ${props => props.disabled ? 'initial' : 'pointer'};
  &:hover {
    color: ${props => props.disabled ? colors.secondary60 : '#000'};
  }
`

const Title = styled.span`
  max-width: 190px;
  word-wrap: break-word;
  padding-left: ${props => props.withPadding ? '12px' : '0'};
`

const FilterTitle = ({ active, disabled, title, onActiveChange, height, badge }) => {
  const onClick = (e) => {
    e.preventDefault()

    if (!disabled && onActiveChange) {
      onActiveChange(!active)
    }
  }

  return (
    <StyledWrapper disabled={disabled} isActive={active} height={height}>
      <ActiveZone disabled={disabled} onClick={e => onClick(e)}>
        <ToggleSwitch disabled={disabled} value={active} />
        {badge}
        <Title withPadding={!badge}>{title}</Title>
      </ActiveZone>
    </StyledWrapper>
  )
}

FilterTitle.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  title: PropTypes.string,
  onActiveChange: PropTypes.func,
  height: PropTypes.number,
  badge: PropTypes.node,
}

export default FilterTitle
